import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getDormakabaConnectionQueryKey } from './get-dormakaba-connection'

type UpdateDormakabaConnectionRequest = {
  buildingId: number
  host: string
  protocol: string
  tokenHost: string
  tokenProtocol: string
  requesterId: string
  username: string
  password: string
  clientId: string
  clientSecret: string
  scope: string
  config?: Record<string, unknown>
}

const updateDormakabaConnection = async (data: UpdateDormakabaConnectionRequest) => {
  const response = await integrationAPI.post('/dormakaba/connection', data)
  return response.data
}

export const useUpdateDormakabaConnection = () =>
  useMutation({
    mutationFn: updateDormakabaConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getDormakabaConnectionQueryKey({ buildingId: variables.buildingId })])
    },
  })
